//파일명 확인
// 응답 헤더 Content-Disposition 에서 파일 이름을 꺼낸다(filename* 의 UTF-8 우선).
export const filenameFromDisposition = (headers) => {
  const cd = (headers && (headers['content-disposition'] || headers['Content-Disposition'])) || '';
  const star = cd.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ''));
    } catch (e) {
      // 아래 일반 filename 으로
    }
  }
  const plain = cd.match(/filename="?([^";]+)"?/i);
  if (!plain) return '';
  try {
    return decodeURIComponent(plain[1].trim());
  } catch (e) {
    return plain[1].trim();
  }
};

export const downloadFile = (file, fileNm, filedoc) => {
  let blob = new Blob([file.data]);
  // 호출부가 커스텀 'filename' 헤더를 읽는데, 일부 API(제품 엑셀 등)는 Content-Disposition 으로만
  // 보내서 "undefined.xlsx" 로 받아졌다(2026-10-15). 이름이 비면 Content-Disposition 에서 찾는다.
  let fileName;
  if (!fileNm || fileNm === 'undefined') {
    const fromCd = filenameFromDisposition(file && file.headers);
    fileName = fromCd || `download.${filedoc}`;
  } else {
    fileName = `${fileNm}.${filedoc}`;
  }

  if (window.navigator.msSaveOrOpenBlob) {
    // IE 10+는 해당 함수 제공
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.target = '_self';
    if (fileName) link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link); //메모리 누수 방지
  }
};
